// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__FVQPl","footer":"ModalFilter_footer__1iEWg"};